import React, { Component } from 'react';
import { get } from 'lodash';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TransactionCard from './TransactionCard';

import { getTransactionsRequest } from 'ducks/users';

class Transactions extends Component {
  state = {
    uiLoaded: this.props.transactions || false,
    isBottom: false
  };

  authentication = () => {
    if (this.props.user) {
      this.props.getTransactionsRequest({ user: this.props.user, page: 1 });
    } else if (this.props.user === false) {
      this.props.history.push('/login');
    }
  };

  handleBottom = () => {
    if (
      this.props.currentPage < this.props.lastPage &&
      this.props.transactions
    ) {
      this.props.getTransactionsRequest({
        user: this.props.user,
        page: this.props.currentPage + 1,
        previous: this.props.transactions
      });
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.user !== this.props.user) {
      this.authentication();
    }

    if (prevProps.uiLoading && !this.props.uiLoading) {
      this.setState({
        uiLoaded: true
      });
    }
  }

  componentDidMount() {
    this.authentication();
    window.dataLayer.push({
      event: 'Land History List'
    });
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>{this.props.t('transactions.header.title')}</title>
        </Helmet>
        <div
          style={{
            backgroundColor: '#f5f5f5',
            margin: '0 auto',
            width: '100%',
            height: '100%',
            maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
          }}>
          <div
            style={{
              padding: '20px 0 0'
            }}>
            <div
              style={{
                fontSize: '16px',
                padding: '0 15px 15px'
              }}>
              {this.props.t('transactions.transactions_title')}
            </div>
            <BottomScrollListener onBottom={this.handleBottom}>
              {scrollRef => (
                <div
                  ref={scrollRef}
                  style={{
                    height: '100%',
                    overflowY: 'scroll',
                    maxHeight: 'calc(100vh - 120px)',
                    display: this.state.uiLoaded ? 'block' : 'none'
                  }}>
                  {this.state.uiLoaded &&
                  this.props.transactions &&
                  this.props.transactions.length > 0 ? (
                    this.props.transactions.map(r => {
                      return (
                        <TransactionCard
                          key={r.ref}
                          t={this.props.t}
                          transaction={r}
                        />
                      );
                    })
                  ) : (
                    <div
                      style={{
                        textAlign: 'center',
                        backgroundColor: '#fbfbfb',
                        padding: '25px 0'
                      }}>
                      <div style={{ paddingBottom: '2px' }}>
                        {this.props.t('transactions.empty')}
                      </div>
                      <Link
                        style={{ textDecoration: 'underline' }}
                        to={`${process.env.PUBLIC_URL}/create-shipment/quotation`}>
                        {this.props.t('transactions.new')}
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </BottomScrollListener>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  getTransactionsRequest
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    authRequestSuccess: state.auth.authRequestSuccess,
    uiLoading: !!state.users.loading,
    currentPage: get(state, 'users.transactions.currentPage') || 1,
    lastPage: get(state, 'users.transactions.lastPage') || 1,
    transactions: get(state, 'users.transactions.data') || false
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Transactions))
);
